module.exports = __webpack_public_path__ + "static/mountain-091ff545bc778da6c45f0a421d9c22e4.jpg";